export default "__VITE_ASSET__1eBIp29d__"